module.exports = {
      id: "icon-timer-usage",
      viewBox: "0 0 15.177 16",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-timer",
      toString: function () {
        return this.url;
      }
    }